var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"title",on:{"click":function($event){return _vm.$emit('click')}}},[_c('h1',{staticClass:"line-1"},[_vm._v(_vm._s(_vm.line1))]),_c('h1',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.line2))]),_c('h2',{staticClass:"action-line"},[_c('span',[_vm._v(_vm._s(_vm.line3))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }